// extracted by mini-css-extract-plugin
export default {"AdminDatePicker":"styles_AdminDatePicker__jd1Hh","danger":"styles_danger__DHqec"};